const longTimeOptions = {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
};
const modifiedLongTimes = {
    tr: (date) => new Intl.DateTimeFormat('tr', Object.assign(Object.assign({}, longTimeOptions), { hour12: true })).format(date),
};
/**
 * Function that returns long time format approved by Wix Localization team.
 * @param locale - language/country short value that is passed to Intl.DateTimeFormat
 * @param date - JavaScript Date objects represent a single moment in time in a platform-independent format.
 */
export const getLongTime = (locale, date) => {
    var _a;
    if (modifiedLongTimes[locale]) {
        return (_a = modifiedLongTimes[locale]) === null || _a === void 0 ? void 0 : _a.call(modifiedLongTimes, date);
    }
    return new Intl.DateTimeFormat(locale, longTimeOptions).format(date);
};
//# sourceMappingURL=getLongTime.js.map